import { ObjectDataRecord } from '@types'

export type PrintableSlot = {
  record: ObjectDataRecord
  globalIndex: number
} | null

export type PrintablePageRows = {
  pageIndex: number
  rows: PrintableSlot[][]
}

/**
 * Делит записи на страницы по сетке cols×rows с добивкой пустыми слотами.
 * Логика совпадает с хелпером Handlebars `paginateGrid`.
 */
export const paginateIntoPages = (
  records: ObjectDataRecord[],
  cols: number,
  rows: number
): PrintablePageRows[] => {
  const ci = Math.floor(cols)
  const ri = Math.floor(rows)
  if (!(ci > 0) || !(ri > 0)) return []

  const perPage = ci * ri
  const pages: PrintablePageRows[] = []

  for (let offset = 0; offset < records.length; offset += perPage) {
    const pageRows: PrintableSlot[][] = []

    for (let r = 0; r < ri; r += 1) {
      const rowSlots: PrintableSlot[] = []

      for (let c = 0; c < ci; c += 1) {
        const posInPage = r * ci + c
        const gi = offset + posInPage
        const record = records[gi]
        rowSlots.push(record !== undefined ? { record, globalIndex: gi } : null)
      }

      pageRows.push(rowSlots)
    }

    pages.push({ pageIndex: pages.length, rows: pageRows })
  }

  return pages
}
